(() => {
  const COLOR_OPTIONS = new Set(['color', 'colour', 'renk']);

  const colorFromInput = (input) => {
    if (!input) return '';
    if (input.dataset.swatchHex) return input.dataset.swatchHex;

    const fieldset = input.closest('fieldset');
    const label = fieldset?.querySelector(`label[for="${CSS.escape(input.id)}"]`);
    const swatch = label?.querySelector('.swatch');
    if (swatch) {
      const bg = getComputedStyle(swatch).getPropertyValue('--swatch--background').trim();
      if (bg) return bg;
    }
    if (label) return getComputedStyle(label).backgroundColor;
    return '';
  };

  const syncColorPreview = () => {
    document.querySelectorAll('fieldset[data-option]').forEach((fieldset) => {
      if (!COLOR_OPTIONS.has(fieldset.dataset.option)) return;

      const input = fieldset.querySelector('input:checked');
      if (!input) return;

      const hex = colorFromInput(input);
      const name = input.value;

      document.querySelectorAll('[data-rexven-garment]').forEach((el) => {
        if (hex) el.style.setProperty('--rexven-garment', hex);
        const nameEl = el.querySelector('[data-rexven-color-name]');
        if (nameEl) nameEl.textContent = name;
      });
    });
  };

  const applyCatalogStyle = () => {
    const styleId = decodeURIComponent((window.location.hash || '').replace('#', ''));
    const panel = styleId ? document.getElementById(styleId) : null;
    const input = document.getElementById('rexven-style-property');
    const title = panel?.dataset.rexvenStyleTitle;

    if (input) input.value = title || '';
    if (!title) return;

    document.title = `${title} – Rexven Print Factory`;
    const crumb = document.querySelector('.rexven-crumbs span:last-child');
    if (crumb) crumb.textContent = title;
  };

  // The Design Now button next to Add to cart opens the Design Studio app block;
  // the block keeps its own design summary and dialog, only its open button is hidden.
  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-rexven-design]');
    if (!button) return;
    event.preventDefault();
    button.closest('.shopify-section')?.querySelector('[data-rds-open]')?.click();
  });

  document.addEventListener('change', (event) => {
    const fieldset = event.target.closest?.('fieldset[data-option]');
    if (!fieldset || !COLOR_OPTIONS.has(fieldset.dataset.option)) return;
    syncColorPreview();
  });

  document.addEventListener('shopify:section:load', syncColorPreview);
  window.addEventListener('hashchange', applyCatalogStyle);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      syncColorPreview();
      applyCatalogStyle();
    });
  } else {
    syncColorPreview();
    applyCatalogStyle();
  }
})();
